import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/gei/auxiliaries/ocatypes/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/gei/auxiliaries/ocatypes/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/gei/auxiliaries/ocatypes/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/gei/auxiliaries/ocatypes/create`,  data)
    },
    update(data) {
        return axios.post(`/gei/auxiliaries/ocatypes/update`,  data)
    },
    delete(id) {
        return axios.delete(`/gei/auxiliaries/ocatypes/delete/${id}`)
    },
}